import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect, useRef, useCallback } from 'react';
import {
  DropDownSelector,
  ButtonBasic,
  InputDinamycPlaceholder,
  CheckboxToggle,
  TableBox,
  Checkbox,
  SearchComponent,
  Tabs
} from '@lk-gtcom/ecomlab-components';
import { SingleDatePicker } from '../../../components/SingleDatePicker/SingleDatePicker';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { FilterContainer } from '../../../components/FilterContainer/FilterContainer';
import { useDataTable } from '../../../common/hooks';
import { StepItem } from '../../../components/StepItem/StepItem';
import { fetchApiFilterVer3 } from '../../../common/filtersFunc';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import useGeneralStore from '../../../store/general';
import './ModalCreateCampaignFromRules.scss';
import { TextPage } from '../../../components/TextPage/TextPage';
import { options_prop_mp } from '../../../common/globalVariables';
import { StepPoints } from '../../../components/StepPoints/StepPoints';
import { ModalHistoryActions } from './ModalHistoryActions/ModalHistoryActions';
import { TimeGridSelector } from '../../../components/TimeGridSelector/TimeGridSelector';
import { fetchMasterBrandFilter, fetchMasterCategoryFilter } from '../../../common/filtersFunc'
import { ModalСonfirmation } from '../Modal/ModalСonfirmation/ModalСonfirmation'
import { RequestController } from '../../../common/filtersFunc';
import { usePushNotifications } from '../../../common/pushNotification';
import { ModalHistoryChangesTasks } from './ModalHistoryChangesTasks/ModalHistoryChangesTasks';
import { periodWeek } from '../../../common/constant';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../common/auth';
import { getValueMultiFilter } from '../../../common/filtersFunc';

const btn_tab = [
  { label: 'Все', value: 'false' },
  { label: 'Добавленные', value: 'true' }
]

const transformOptions = (opinion_param) => {
  const result = {};

  opinion_param.forEach(item => {
    const opinionId = item.opinion_id.toString(); // ключ - строка
    if (!result[opinionId]) {
      result[opinionId] = [];
    }
    result[opinionId].push({
      id: item.param_id,
      name: item.param_name
    });
  });

  return result;
}


function validateRequiredValues(attrs) {
  return attrs.every(attr => {
    if (attr.required) {
      return attr.value !== null && attr.value !== undefined;
    }
    return true;
  });
}

const ModalCreateCampaignFromRules = ({
  setIsModal,
  currentСampaign,
  setCurrentСampaign
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  // Рефы
  const fileInputRef = useRef(null);

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const [apiData, setApiData] = useState([]);
  const [strategiesList, setStrategiesList] = useState([]);
  const [paramsList, setParamsList] = useState([])
  const [optionList, setOptionList] = useState(currentСampaign ? currentСampaign?.strat_param : [])

  const [selectedMarketplace, setSelectedMarketplace] = useState(currentСampaign?.mp_id ?
    options_prop_mp.filter(({ value }) => value == currentСampaign?.mp_id)?.[0] : options_prop_mp[0]);
  const [selectedApi, setSelectedApi] = useState(currentСampaign ? currentСampaign?.api_id : []);
  const [selectedStrategies, setSelectedStrategies] = useState(currentСampaign ? {
    label: currentСampaign?.strategy?.name,
    value: currentСampaign?.strategy?.id,
    description: currentСampaign?.strategy?.description
  } : [])

  const [apiPage, setApiPage] = useState(1);
  const [apiQuery, setApiQuery] = useState('');
  const [title, setTitle] = useState(currentСampaign?.name || '');

  const [isCheck, setIsCheck] = useState(currentСampaign ? currentСampaign?.is_active : false);
  const [isCheckSchedule, setIsCheckSchedule] = useState(false);

  const [paramsValues, setParamsValues] = useState(currentСampaign ? currentСampaign?.strat_param : [])

  const [optionValues, setOptionValues] = useState(currentСampaign?.opinion_param?.length ? currentСampaign?.opinion_param : [])
  const [isCheckOptions, setIsCheckOptions] = useState(currentСampaign?.option_id_list?.length ? currentСampaign?.option_id_list : [])
  const [isDeleteArrayOption, setIsDeleteArrayOption] = useState([])
  const [paramsListOptions, setParamsListOptions] = useState(currentСampaign?.opinion_param?.length ? transformOptions(currentСampaign?.opinion_param) : {})
  const [currentStep, setCurrentStep] = useState(1)

  const [isSave, setIsSave] = useState(currentСampaign?.id)
  const [isAllCheck, setIsAllCheck] = useState(false)

  // Атрибуты

  const [attrList, setAttrList] = useState([])
  const [productTemporary, setProductTemporary] = useState([])
  const [errField, setErrField] = useState(false)

  const [selectedRange, setSelectedRange] = useState([])

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );

  const paginatorRef2 = useRef();
  const [setTable2 = setTable, tableProps2 = tableProps, setTableFuncs2 = setTableFuncs] = useDataTable(
    paginatorRef2.current?.setTotal,
    paginatorRef2
  );
  const [loading2, setLoading2] = useState(false)
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [selectedItems, setSelectedItems] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)

  // Табы 
  const [currentTab, setCurrentTab] = useState(btn_tab[0].value)

  // Логи
  const [logCount, setLogCount] = useState(0)

  // Фильтры
  const curr_brand = currentСampaign?.strat_param_filter?.filter(({ param_id }) => param_id == 10)?.[0]
  const default_category = (selectedStrategies?.value == 7) ? curr_brand : [{ label: 'Все', value: 'all' }]

  const curr_category = currentСampaign?.strat_param_filter?.filter(({ param_id }) => param_id == 4)?.[0]
  const default_brand = (selectedStrategies?.value == 7) ? curr_category : [{ label: 'Все', value: 'all' }]

  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(default_category);
  const [selectedBrand, setSelectedBrand] = useState(default_brand);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  // Фильтры новые 
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const [isClear, setIsClear] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);

  // табы
  const [pageContent, setPageContent] = useState('false');

  const [selectedFile, setSelectedFile] = useState(false)
  const [isModalConfirmation, setIsModalConfirmation] = useState(false)

  const [defaultDate, setDefaultDate] = useState('');
  const [dateTime, setDateTime] = useState(periodWeek());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date())

  const [startDateTask, setStartDateTask] = useState(new Date());
  const [endDateTask, setEndDateTask] = useState(new Date())

  const refContainer1 = useRef()
  const refContainer2 = useRef()

  // Чекбокс
  const [isCheckAllProduct, setIsCheckAllProduct] = useState(false)
  const [isSetPeriod, setIsSetPeriod] = useState(false)

  const setDataFromJson = (
    json,
    page,
    setState,
    withAll = true,
    mapFunc = (el) => ({ label: el.name, value: el.id })
  ) => {
    const dataArr = json.map(mapFunc);
    if (page > 1) {
      setState((prev) => [...prev, ...dataArr]);
    } else {
      if (withAll) setState([...dataArr]);
      else setState([...dataArr]);
    }
  };

  const fetchDictValues = (page, query, setOptions, data, signal) => {
    if (data) {
      const { id } = data
      const limit = 25
      const offset = page ? (page - 1) * limit : 0
      const url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/attributes/${id}/dictionary_values`
      const body = JSON.stringify({
        limit,
        offset,
        filter_value: query
      })
      fetch(url, { method: 'POST', headers, body, signal })
        .then(res => res.json())
        .then(json => setDataFromJson((json?.filter_data || json), page, setOptions, false, el => ({ label: el, value: el })))
        .catch(e => console.error(e))
    }
  }

  const resetTable = () => {
    paginatorRef?.current?.reset();
    paginatorRef?.current?.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  const filtersMasterCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchMasterCategoryFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      dateFrom,
      dateTo,
      brandData,
      selectedBrand,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersMasterBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchMasterBrandFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      categoryData,
      selectedCategory,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      setBrandData: (e) => setBrandData(e),
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const handleSearch = useCallback((e) => {
    const abortController = new AbortController();
    fetchSearch(e, abortController);
    return () => abortController.abort();
  });

  useEffect(() => {
    if (currentСampaign?.id) {
      setIsSave(true)
    }
  }, [currentСampaign?.id]);

  useEffect(() => {
    filtersMasterCategory();
  }, [categoryPage, categoryQuery, dateFrom, dateTo]);

  useEffect(() => {
    filtersMasterBrand();
  }, [dateFrom, dateTo, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  // Modal 
  const [isModalLog, setIsModalLog] = useState(false)


  const categoryFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      setTable: setTotalApi,
      page: categoryPage,
      selectedShop: selectedMarketplace,
      apiData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category',
    });
  };

  useEffect(() => {
    categoryFilter();
  }, [categoryPage, categoryQuery]);

  const brandFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      setTable: setTotalBrand,
      apiData,
      categoryData,
      selectedApi,
      selectedShop: selectedMarketplace,
      selectedCategory,
      selectedBrand,
      page: brandPage,
      searchParam: brandQuery,
      set: setBrandData,
      setBrandData: (e) => setBrandData(e),
      filter: 'brand',
    });
  };

  useEffect(() => {
    brandFilter();
  }, [brandPage, brandQuery]);

  // Поиск
  const fetchSearch = ( [search, page = 1], abortController = new AbortController() ) => {

    let url = `https://apps0.ecomru.ru:4449/v2/mp-products/filters/offer-id-name`

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setSearchData(json?.filter_data?.map(({ id, name }) => ({ label: name, value: id }))))
      .catch(handleRequestError);
  };

  // Создание задачи
  const fetchСreateСampaign = () => {
    setLoading(true);
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks`

    const body = JSON.stringify({
      is_active: isCheck,
      name: title,
      api_id: selectedApi,
      strategy_id: selectedStrategies?.value,
      mp_id: selectedMarketplace?.value,
      start_at: isSetPeriod ? startDateTask : null,
      finish_at: isSetPeriod ? endDateTask : null,
      // strat_params: paramsValues,
      // option_id_list: isCheckOptions,
      // option_params: optionValues
    })

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        setCurrentСampaign(json)
        setIsSave(true)
      })
      .catch(handleRequestError)
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  // Редактирование задачи
  const fetchChangeСampaign = () => {
    setLoading(true);
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}`

    const body = JSON.stringify({
      is_active: isCheck,
      name: title,
      strategy_id: selectedStrategies?.value,
      api_id: selectedApi,
      mp_id: selectedMarketplace?.value,
      start_at: isSetPeriod ? startDateTask : null,
      finish_at: isSetPeriod ? endDateTask : null,
      // strategy_id: paramsValues.map(({ param_id, value }) => ({ param_id, value })),
      // option_id_list: isCheckOptions,
      // option_params: optionValues
    })

    fetch(url, { body, method: 'PUT', headers })
      .then(handleTableResponse)
      .then((json) => setIsSave(true))
      .catch(handleRequestError)
      .finally(() => setTimeout(() => setLoading(false), 1000));
  };

  // Получение стратегий
  const fetchGetStrategies = () => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/strategies`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const current_option = json.map(({ id, name, description }) => {
          return {
            label: name,
            value: id
          }
        })
        setStrategiesList(current_option)
      })
      .catch(handleRequestError);
  };

  // Получение атрибутов задачи
  const fetchGetAttrTask = () => {
    setAttrList([])
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/attributes`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.attrs) {
          setProductTemporary(json?.attrs)
        }
      })
      .catch(handleRequestError);
  };

  // Сохранение значений атрибутов
  const fetchSetAttr = () => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/attributes`

    const body = JSON.stringify({
      attrs: productTemporary
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => fetchTableDataCommission(), 500))
      .catch(handleRequestError);
  };

  // Получение таблицы цен
  const fetchTableDataPrice = (params, abortController = new AbortController()) => {
    if (!currentСampaign?.id) return

    setLoading(true)
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-prices/table?only_with_task_price=${pageContent}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_direction=' + sort[1]
      : ''
      }`

    let brand_id_list;
    let category_id_list;
    let offer_id_list = searchValue ? [searchValue] : []

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
      filters: filtersParam,
      offer_id_list
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Получение таблицы комиссий (для маржинальности)
  const fetchTableDataCommission = (params, abortController = new AbortController()) => {
    if (!currentСampaign?.id) return

    setLoading(true)
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/price-attrs/table${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_direction=' + sort[1]
      : ''
      }`

    const body = JSON.stringify({
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Получение таблицы цен стратегия 5
  const fetchTableDataPriceTime = (params, abortController = new AbortController()) => {
    if (!currentСampaign?.id) return
    if (selectedStrategies?.value !== 5) return

    setLoading(true)
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `https://apps0.ecomru.ru:4142/products/${currentСampaign?.id}/show?status=${pageContent === 'false' ? 'all' : 'active'}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`

    let api_id_list = [];
    let offer_id_list = searchValue ? [searchValue] : []

    if (selectedApi) {
      api_id_list = [selectedApi.value]
    }

    const body = JSON.stringify({
      api_id_list,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      limit: paginatorRef.current?.limit || 10,
      page: paginatorRef.current?.page || 1,
      filters: filtersParam || [],
      offer_id_list,
      date_from: "2025-08-10",
      date_to: "2025-08-18",
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) =>  setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  // Получение таблицы ссылок
  const fetchTableDataLink = (params, abortController = new AbortController()) => {
    if (!currentСampaign?.id) return
    if (selectedMarketplace?.value != 2) return

    setLoading2(true)
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-urls/table?only_with_task_url=${pageContent}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_direction=' + sort[1]
      : ''
      }`

    let brand_id_list;
    let category_id_list;
    let offer_id_name_search = searchValue;

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      limit: paginatorRef2.current?.limit || 10,
      page: paginatorRef2.current?.page || 1,
      filters: filtersParam,
      offer_id_name_search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable2(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading2(false);
      });
  };

  // Скачать шаблон цен
  const fetchGetTemplate = async () => {
    const url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-prices/excel-template`;

    try {
      // 1. Получаем JSON с URL файла
      const response = await fetch(url, { method: 'GET', headers });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      const json = await response.json();
      if (!json?.url) throw new Error("URL файла не найден в ответе");

      // 2. Создаём скрытую ссылку и скачиваем файл
      const link = document.createElement('a');
      link.href = json.url;
      link.download = 'price_template.xlsx'; // Имя файла
      link.style.display = 'none'; // Скрываем ссылку
      document.body.appendChild(link);
      link.click(); // Автоматический клик

      // 3. Очищаем ссылку через небольшой таймаут
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    } catch (err) {
      console.error('Ошибка:', err);
    }
  };

  // Скачать шаблон ссылок
  const fetchGetTemplateLinks = async () => {
    const url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-urls/excel-template`;

    try {
      // 1. Получаем JSON с URL файла
      const response = await fetch(url, { method: 'GET', headers });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      const json = await response.json();
      if (!json?.url) throw new Error("URL файла не найден в ответе");

      // 2. Создаём скрытую ссылку и скачиваем файл
      const link = document.createElement('a');
      link.href = json.url;
      link.download = 'links_template.xlsx'; // Имя файла
      link.style.display = 'none'; // Скрываем ссылку
      document.body.appendChild(link);
      link.click(); // Автоматический клик

      // 3. Очищаем ссылку через небольшой таймаут
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    } catch (err) {
      console.error('Ошибка:', err);
    }
  };

  // Загрузить шаблон
  const onUploadFileToPromotion = (file, status) => {
    if (!file) {
      return;
    }

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-prices/by-excel?replace_old=${status}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, { method: 'POST', updatedHeaders, headers: updatedHeaders, body: formData })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`)
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        const string_response = <>
          Всего артикулов в файле: {data?.total_count || '-'},<br />
          Успешно добавлены: {data?.success_count || '-'},<br />
          С ошибками: {data?.error_count || '-'},<br />
          Список артикулов, которых нет в магазине: {data?.not_found_offer_ids?.length ? data?.not_found_offer_ids?.join(', ') : '-'}
        </>
        addSuccessPush(string_response, 20000);
        if (fileInputRef.current) fileInputRef.current.value = ''
        setIsTableRequest(!isTableRequest)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
        setSelectedFile(null)
      })
  };

  // Загрузить шаблон ссылок
  const onUploadFileToLinks = (file, status) => {
    if (!file) {
      return;
    }
    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-urls/by-excel?replace_old=${status}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          alert(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return res.json();
      })
      .then((data) => {
        alert('Успешная загрузка');
        // setTimeout(() => fetchTableDataLink(), 1000)
      })
      .catch(handleRequestError)
  };

  // Загрузить шаблон стратегия 5
  const onUploadFileToTime = (file, status) => {
    if (!file) {
      return;
    }
    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps0.ecomru.ru:4142/products/${currentСampaign?.id}/update_from_excel?action=${status ? 'replace' : 'add'}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`)
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        const string_response = <>
          Всего артикулов в файле: {data?.total_count || '-'},<br />
          Успешно добавлены: {data?.success_count || '-'},<br />
          С ошибками: {data?.error_count || '-'},<br />
          Список артикулов, которых нет в магазине: {data?.not_found_offer_ids?.length ? data?.not_found_offer_ids?.join(', ') : '-'}
        </>
        addSuccessPush(string_response, 20000);
        if (fileInputRef.current) fileInputRef.current.value = ''
        setIsTableRequestTime(!isTableRequestTime)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
        setSelectedFile(null)
      })
  };

  // Загрузить шаблон стратегия 5 для ВБ
  const onUploadFileToTimeWB = (file, status) => {
    if (!file) {
      return;
    }
    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps0.ecomru.ru:4142/wb_products/${currentСampaign?.id}/update_from_excel?action=${status ? 'replace' : 'add'}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`)
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        const string_response = <>
          Всего артикулов в файле: {data?.total_count || '-'},<br />
          Успешно добавлены: {data?.success_count || '-'},<br />
          С ошибками: {data?.error_count || '-'},<br />
          Список артикулов, которых нет в магазине: {data?.not_found_offer_ids?.length ? data?.not_found_offer_ids?.join(', ') : '-'}
        </>
        addSuccessPush(string_response, 20000);
        if (fileInputRef.current) fileInputRef.current.value = ''
        setIsTableRequestTime(!isTableRequestTime)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
        setSelectedFile(null)
      })
  };

  // Очистить цены
  const fetchClearPrice = (id, row_id) => {
    setAttrList([])
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-prices`

    const body = JSON.stringify({
      prices: [
        {
          offer_id: id,
          row_id
        }
      ]
    })

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then((json) => setIsTableRequest(!isTableRequest))
      .catch(handleRequestError);
  };

  // Очистить ссылки
  const fetchClearLink = (id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-urls`

    const body = JSON.stringify({
      urls: [
        {
          offer_id: id
        }
      ]
    })

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        // setTimeout(() => fetchTableDataLink(), 500)
      })
      .catch(handleRequestError);
  };

  // Очистить ссылки стратегия 5
  const fetchClearPriceTime = (id) => {
    let url = `https://apps0.ecomru.ru:4142/products/${currentСampaign?.id}/update`

    const body = JSON.stringify({
      add: [],
      delete: [id]
    });


    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setIsTableRequestTime(!isTableRequestTime))
      .catch(handleRequestError);
  };

  // Очистить ссылки стратегия 5
  const fetchClearPriceTimeWB = (id) => {
    let url = `https://apps0.ecomru.ru:4142/wb_products/${currentСampaign?.id}/update`

    const body = JSON.stringify({
      add: [],
      delete: [id]
    });


    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setIsTableRequestTime(!isTableRequestTime))
      .catch(handleRequestError);
  };

  // Установить период
  const fetchSetRange = (id) => {
    let url;
    let body;

    if (selectedStrategies?.value == 5) {
      url = `https://apps0.ecomru.ru:4142/set_schedule?action=replace`

      body = JSON.stringify({
        task_id: currentСampaign?.id,
        schedule_dict: selectedRange
      })
    } else {
      url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/schedule`

      body = JSON.stringify({
        schedules: selectedRange
      })
    }

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {})
      .catch(handleRequestError);
  };

  // Получить период
  const fetchGetRange = (id) => {
    let url;

    if (selectedStrategies?.value == 5) {
      url = `https://apps0.ecomru.ru:4142/get_schedule?task_id=${currentСampaign?.id}`
    } else {
      url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/schedule`
    }

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.schedules && selectedStrategies?.value != 5) {
          setSelectedRange(json?.schedules)
        } else {
          setSelectedRange(json)
        }
      })
      .catch(handleRequestError);
  };

  // Установить цены
  const fetchSetPrice = (price, offerId, setStatus, colName, row_id) => {

    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-prices`

    const prices = [{
      [colName]: price,
      offer_id: offerId,
      row_id
    }];

    const body = JSON.stringify({ prices });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {})
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  // Установить цены стратегия 5
  const fetchSetPriceTime = (price, offerId, setStatus, colName) => {

    let url = `https://apps0.ecomru.ru:4142/products/${currentСampaign?.id}/update`

    const price_param = colName == 'Новая цена после скидки'
      ?
      { new_price_after_discount: price } : { new_price_before_discount: price }

    const body = JSON.stringify({
      add: [{
        ...price_param,
        offer_id: offerId
      }]
      ,
      delete: []
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  // Установить цены стратегия 5 WB
  const fetchSetPriceTimeWB = (price, offerId, setStatus, colName,) => {

    let url = `https://apps0.ecomru.ru:4142/wb_products/${currentСampaign?.id}/update`

    const price_param = () => {
      if (colName == 'Новая цена после скидки') {
        return { new_price_after_discount: price }
      } else if (colName == 'Новая скидка, %') {
        return { discount: price }
      } else {
        return { new_price_before_discount: price }
      }
    }

    const body = JSON.stringify({
      add: [{
        ...price_param(),
        offer_id: offerId
      }]
      ,
      delete: []
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  // Установить ссылки
  const fetchSetLink = (price, offerId, setStatus, colName) => {

    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-urls`

    const urls = [{
      product_url: price,
      offer_id: offerId
    }];

    const body = JSON.stringify({ urls });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => console.log(json))
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  // Получение параметров стратегий
  const fetchGetParams = () => {
    setParamsList()
    const strategies = [1, 4, 6, 7]
    if (!strategies.includes(selectedStrategies?.value)) return
    let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/parameters?strat_id=${selectedStrategies?.value}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const current = json.map(({ id, name }) => ({ param_id: id, param_name: name }))
        setParamsList(current)
        if (!currentСampaign) {
          setParamsValues([])
        }
      })
      .catch(handleRequestError);
  };

  // Установка цен в таблице - тогл
  const fetchChangeStatusTask = (task_id, offer_id, status) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/offer-usage`

    const body = JSON.stringify({
      offer_id,
      active: status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => setIsTableRequest(!isTableRequest), 100))
      .catch(handleRequestError);
  }

  // Установка цен в таблице - тогл "ВСЕ"
  const fetchChangeStatusTaskAll = (status) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}/offer-usage/all-offers`

    const body = JSON.stringify({
      active: status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => setIsTableRequest(!isTableRequest), 100))
      .catch(handleRequestError);
  }

  // Установка параметров комиссии - тогл
  const fetchChangeStatusCommision = (task_id, key, status) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/price-attrs-usage`

    const body = JSON.stringify({
      key,
      active: status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) =>  fetchTableDataCommission())
      .catch(handleRequestError);
  }

  const [isStart, setIsStart] = useState(false)

  // запустить сейчас
  const fetchStart = (task_id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/start`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        setIsStart(true)
        setIsCheck(true)
      })
      .catch(handleRequestError);
  }

  // Получение информации все ли товары выбраны для стратегии 4
  const fetchGetSelectedAllWithCost = (task_id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/margin-strategy/attributes/use-all-products`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const { use_all_products } = json
        setIsCheckAllProduct(use_all_products)
      })
      .catch(handleRequestError);
  }

  useEffect(() => {
    if (selectedStrategies?.value === 4) {
      fetchGetSelectedAllWithCost(currentСampaign?.id)
    }
  }, [currentСampaign?.id]);

  // Выбрать все товары для стратегии 4
  const fetchSelectedAllCWithCost = (task_id, status) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/margin-strategy/attributes/use-all-products`

    const body = JSON.stringify({
      use_all_products: status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        if (!status) {
          setTimeout(() => fetchTableDataPrice(), 500)
        }
      })
      .catch(handleRequestError);
  }

  // чекбокс опций для стратегии 5
  const fetchCheckSchedule = (task_id, status) => {
    let url = `https://apps0.ecomru.ru:4142/api/v1/tasks/task/${task_id}/set_promotions`

    const body = JSON.stringify({
      in_promotions: status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => { })
      .catch(handleRequestError);
  }


  // Сделать предварительный расчет цен
  const fetchPreliminaryPriceCalculation = async (task_id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${task_id}/calculated-price-excel-report`;

    try {
      // Выполняем GET-запрос (или другой метод, если требуется)
      const response = await fetch(url, {
        method: 'POST', // или 'POST', если необходимо
        headers
      });

      // Проверяем, успешен ли ответ
      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
      }

      // Извлекаем имя файла из заголовка Content-Disposition, если оно есть
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'calculated-price-report.xlsx'; // имя по умолчанию

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch) {
          filename = decodeURIComponent(filenameMatch[1]);
        }
      }

      // Преобразуем ответ в Blob
      const blob = await response.blob();

      // Создаем временную ссылку для скачивания
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename; // Устанавливаем имя файла
      document.body.appendChild(link);
      link.click(); // Имитируем клик для скачивания

      // Убираем ссылку и освобождаем URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error('Ошибка при скачивании файла:', error);
      // Можно добавить обработку ошибок, например, уведомление пользователя
    }
  };

  // Тогл для таблицы - стратегия маржинальности
  const handleToggle = (data) => {
    fetchChangeStatusTask(currentСampaign?.id, data?.offer_id, !data?.is_active);
  };

  // Тогл для таблицы - стратегия маржинальности
  const handleToggleCommision = (data) => {
    fetchChangeStatusCommision(currentСampaign?.id, data?.['Использовать в расчетах']?.[1], !data?.['Использовать в расчетах']?.[0]);
  };

  // Получить время задачи для
  const fetchGetRangeTaskTime = () => {
    if(!currentСampaign?.id) return
    let url = `https://apps0.ecomru.ru:4142/api/v1/tasks/task/${currentСampaign?.id}/get_time`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const start_time = json?.start_time
        const end_time = json?.end_time

        if (start_time) {
          setStartDate(new Date(start_time))
        }
        if (end_time) {
          setEndDate(new Date(end_time))
        }

      })
      .catch(handleRequestError);
  };

  // Получить чекбокс опции 5 стратегии
  const fetchGetSchedule = () => {
    if(currentСampaign?.id) return
    let url = `https://apps0.ecomru.ru:4142/api/v1/tasks/task/${currentСampaign?.id}/get_promotions`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setIsCheckSchedule(json?.in_promotions))
      .catch(handleRequestError);
  };

  useEffect(() => {
    if (selectedStrategies?.value == 5) {
      fetchGetRangeTaskTime()
      fetchGetSchedule()
    }
  }, [selectedStrategies]);

  // Установить время задачи для
  const fetchSetRangeTaskTime = () => {
    let url = `https://apps0.ecomru.ru:4142/api/v1/tasks/task/${currentСampaign?.id}/set_time`

    const body = JSON.stringify({
      end_time: endDate,
      start_time: startDate
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) =>  console.log(json))
      .catch(handleRequestError);
  };

  const handleSaveOnePrice = async (e) => {
    console.log(e)
    const { inputEvent, actionEvent, setStatus } = e;
    const rowId = actionEvent?.[0]?.row_id
    const offerId = inputEvent.id;
    // const productId = actionEvent?.[0]?.product_id;
    const colName = actionEvent?.[2];
    const newPrice = inputEvent?.value

    setStatus('loading');
    fetchSetPrice(newPrice, offerId, setStatus, colName, rowId)
  };

  const handleSaveOnePriceTime = async (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = actionEvent?.[0]?.["Товар"]?.[4]
    const colName = actionEvent?.[2];
    const newPrice = inputEvent?.value;

    setStatus('loading');
    if (selectedMarketplace?.value === 3) {
      fetchSetPriceTimeWB(newPrice, offerId, setStatus, colName)
    } else {
      fetchSetPriceTime(newPrice, offerId, setStatus, colName)
    }

  };

  const handleSaveOneLink = async (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent.id;
    // const productId = actionEvent?.[0]?.product_id;
    const colName = actionEvent?.[2];
    const newPrice = inputEvent?.value;

    setStatus('loading');
    fetchSetLink(newPrice, offerId, setStatus, colName)
  };

  const handleFileChange = async (e) => {
    setIsModalConfirmation(true)
    setSelectedFile(e.target.files[0])
  };

  const handleFileChangeLink = async (e) => {
    setIsModalConfirmation(true)
    setSelectedFile(e.target.files[0])
  };

  const handleFileChangeTime = async (e) => {
    setIsModalConfirmation(true)
    setSelectedFile(e.target.files[0])
  };

  const handleCheck = (data) => {
    setSelectedItems(data)
  }

  const contextMenuArr = [
    { label: 'Очистить', onClick: (e) => fetchClearPrice(e?.offer_id, e?.row_id)},
  ];

  const contextMenuArr2 = [
    {
      label: 'Очистить',
      onClick: (e) => {
        fetchClearLink(e?.offer_id)
      }
    },
  ];

  // Ддя стратегии 5
  const contextMenuArr3 = [
    {
      label: 'Очистить',
      onClick: (e) => {
        const offerId = e?.["Товар"]?.[4]
        if (selectedMarketplace?.value === 3) {
          fetchClearPriceTimeWB(offerId)
        } else {
          fetchClearPriceTime(offerId)
        }

      }
    },
  ];

  const fetchDeleteOption = (id) => {
    let url = `https://apps1.ecomru.ru:4450/api/v1/opinion/delete`

    const body = JSON.stringify({
      uid: currentСampaign?.uid,
      opinion_id_list: isDeleteArrayOption
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        console.log(json)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onCloseModal = () => {
    setIsModal(false)
    setCurrentСampaign(null)
  }

  // Начало и конец задачи
  useEffect(() => {
    const start_time = currentСampaign?.start_at
    const end_time = currentСampaign?.finish_at

    if (start_time) {
      setStartDateTask(new Date(start_time))
      setIsSetPeriod(true)
    }
    if (end_time) {
      setEndDateTask(new Date(end_time))

    }
    setIsSetPeriod((start_time && end_time) ? true : false)
  }, [currentСampaign]);

  useEffect(() => {
    fetchGetParams()
  }, [selectedStrategies]);

  useEffect(() => {
    fetchGetStrategies()
  }, [selectedMarketplace, selectedApi]);

  const apiFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      filter: 'api_id',
    });
  };

  useEffect(() => {
    apiFilter();
  }, [apiPage, apiQuery]);

  const isDisabled = !selectedMarketplace?.value || !selectedApi?.value || !title || !selectedStrategies?.value

  // useEffect(() => {
  //   if (currentСampaign?.strat_param && paramsValues?.length) {
  //     const valueMap = Object.fromEntries((currentСampaign?.strat_param)?.map(item => [item.param_id, item.value]));
  //     const result = paramsValues.map(item => ({
  //       ...item,
  //       value: valueMap[item.id] || null
  //     }));
  //    setParamsValues(result);
  //   }
  // }, [currentСampaign?.strat_param]);

  useEffect(() => {
    if (!(selectedStrategies?.value && title)) {
      setCurrentStep(1)
    }
  }, [selectedStrategies, title]);

  const currentCountStep = () => {
    if (selectedStrategies?.value == 5) {
      return 4
    } else if (selectedStrategies?.value === 4) {
      return 5
    } else {
      return 4
    }
  }

  const [initLoadDate, setInitLoaderDate] = useState(true)

  useEffect(() => {
    if (!initLoadDate) {
      fetchSetRangeTaskTime();
      setInitLoaderDate(false);
    }
  }, [dateTime]);

  useEffect(() => {
    if (currentСampaign) {
      setCurrentStep(2)
    }
  }, [currentСampaign]);

  const getUploadHandler = () => {
    if (selectedStrategies?.value === 5 && selectedMarketplace?.value !== 3) {
      return onUploadFileToTime;
    } else if (selectedStrategies?.value === 5 && selectedMarketplace?.value === 3) {
      return onUploadFileToTimeWB;
    } else {
      return onUploadFileToPromotion;
    }
  };

  useEffect(() => {
    const shouldFetchCommissionData =
      (currentStep === 4 && selectedStrategies?.value === 4) ||
      (currentStep === 5 && selectedStrategies?.value === 4);

    if (shouldFetchCommissionData) {
      resetTable();
      fetchTableDataCommission();
    }
  }, [currentStep, selectedStrategies?.value]);

  useEffect(() => {
    const shouldFetchCommissionData =
      (currentStep === 4 && selectedStrategies?.value === 4) ||
      (currentStep === 5 && selectedStrategies?.value === 4);

    if (currentСampaign?.id) {
      fetchGetAttrTask()
      fetchGetRange()

      if (currentStep != 4) {
        paginatorRef.current?.reset();
        paginatorRef.current?.setTotal(0);

        if (selectedStrategies?.value == 5) {
          setIsTableRequestTime(!isTableRequestTime)
        } else {
          if (!shouldFetchCommissionData) {
            if (selectedStrategies?.value === 4 && isCheckAllProduct) {
              return
            } else {
              setIsTableRequest(!isTableRequest)
            }
          }
        }
      }
    }
  }, [currentСampaign, selectedStrategies, pageContent, isCheckAllProduct]);

  const [isTableRequest, setIsTableRequest] = useState(false);

  useEffect(() => {
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
    const abortController = new AbortController();
    fetchTableDataPrice([], abortController)

    return () => abortController.abort();
  }, [isTableRequest]);

  const [isTableRequestTime, setIsTableRequestTime] = useState(false);

  useEffect(() => {
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
    const abortController = new AbortController();
    fetchTableDataPriceTime([], abortController)

    return () => abortController.abort();
  }, [isTableRequestTime]);

  const [isModalHistoryChangesTasks, setIsModalHistoryChangesTasks] = useState(false)

  return (
    <>
      {
        isModalLog && <ModalHistoryActions
          setIsModal={setIsModalLog}
          uid={currentСampaign?.uid}
        />}

      {
        isModalConfirmation && <ModalСonfirmation
          setIsModal={setIsModalConfirmation}
          onUploadFile={getUploadHandler()}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />}

      {isModalHistoryChangesTasks &&
        <ModalHistoryChangesTasks
          setIsModal={setIsModalHistoryChangesTasks}
          currentTask={currentСampaign?.id}
        />
      }

      <ModalComponent
        onClose={onCloseModal}
        title={currentСampaign ? `Редактирование задачи` : `Добавление новой задачи`}
        styleContent={{
          padding: 0
        }}
        childHeader={
          <div className="modal-create-campaign-from-rules-v2__header">

            <label className="modal-create-campaign-from-rules-v2__label">
              <CheckboxToggle
                text='Активно'
                value={isCheck}
                onChange={(e) => setIsCheck(!isCheck)}
              />
            </label>
          </div>
        }
        child={
          <div className="modal-create-campaign-from-rules-v2" >
            <div className="modal-create-campaign-from-rules-v2__main-content">
              <div className="modal-create-campaign-from-rules-v2__left-content">
                <TitlePage
                  medium
                  title='Общие параметры'
                />

                <InputDinamycPlaceholder
                  position="left"
                  maxWidth="100%"
                  isOpen={true}
                  onChange={(value) => {
                    setTitle(value)
                    setIsSave(false)
                    setCurrentStep(1)
                  }}
                  changeValue={title}
                  placeholder="Введите название кампании"
                  size="s"
                  required={true}
                />

                <div className="modal-create-campaign-from-rules-v2__select-group">
                  <DropDownSelector
                    required={true}
                    state={selectedMarketplace}
                    options_prop={options_prop_mp}
                    total={options_prop_mp?.length}
                    setState={(e) => {
                      setSelectedMarketplace(e)
                      setIsSave(false)
                      setCurrentStep(1)
                    }}
                    placeholder="Площадка"
                    onBlur={() => {
                      apiFilter()
                      brandFilter()
                      categoryFilter()
                      setIsTableRequest(!isTableRequest)
                    }}
                    disabled={currentСampaign}
                  />

                  <DropDownSelector
                    state={selectedApi}
                    options_prop={apiData}
                    total={totalApi}
                    setState={(e) => {
                      setSelectedApi(e)
                      setIsSave(false)
                      setCurrentStep(1)
                    }}
                    placeholder="Магазин"
                    fetchCallback={setApiPage}
                    setInputChange={setApiQuery}
                    required={true}
                    onBlur={() => {
                      brandFilter()
                      categoryFilter()
                      setIsTableRequest(!isTableRequest)
                    }}
                    disabled={currentСampaign}
                  />
                </div>

                <TitlePage
                  medium
                  title='Выбор стратегии'
                />

                <DropDownSelector
                  state={selectedStrategies}
                  options_prop={strategiesList}
                  setState={(e) => {
                    setSelectedStrategies(e)
                    setIsSave(false)
                    setCurrentStep(1)
                  }}
                  placeholder="Стратегия"
                  required={true}
                  disabled={currentСampaign}
                  maxWidth='100%'
                // disabled={currentСampaign}
                />

                <TitlePage
                  medium
                  title='Выбор периода работы задачи'
                />

                <Checkbox
                  value={isSetPeriod}
                  onChange={(e) => setIsSetPeriod(!isSetPeriod)}
                >
                  Установить период
                </Checkbox>

                {isSetPeriod && <div className='modal-create-campaign-from-rules-v2__date-group'>
                  <label className='modal-create-campaign-from-rules-v2__label-date-main'>
                    <TextPage
                      text='Дата начала работы задачи'
                    />
                    <SingleDatePicker
                      date={startDateTask}
                      setDate={(e) => setStartDateTask(e)}
                      minDate={new Date()}
                      // disabled={isEdit}
                      time
                    />
                  </label>

                  <label className='modal-create-campaign-from-rules-v2__label-date-main'>
                    <TextPage
                      text='Дата конца работы задачи'
                    />
                    <SingleDatePicker
                      date={endDateTask}
                      setDate={(e) => setEndDateTask(e)}
                      minDate={new Date()}
                      // disabled={isEdit}
                      time
                    />
                  </label>
                </div>}

                <ButtonBasic
                  green
                  text="Сохранить"
                  size='56px'
                  onClick={(e) => {
                    if (currentСampaign) {
                      fetchChangeСampaign()
                      if (isSave) {
                        onCloseModal()
                      }
                    } else {
                      fetchСreateСampaign()
                    }
                  }}
                  style={{ marginTop: 'auto' }}
                  disabled={isDisabled}
                />
              </div>

              <div className="modal-create-campaign-from-rules-v2__right-content">
                <ButtonBasic
                  blue
                  onClick={(e) => setIsModalHistoryChangesTasks(true)}
                  text={`Посмотреть историю`}
                  style={{ marginLeft: 'auto', minHeight: '40px' }}
                  size='40px'
                />

                <div className='modal-create-campaign-from-rules-v2__toolbar'>
                  <StepPoints
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    totalSteps={currentCountStep()}
                  />

                  <ButtonBasic
                    green
                    text="Следующий щаг"

                    onClick={(e) => {
                      setCurrentStep(currentStep + 1)

                      // Отправка запроса на установку периода
                      if (currentStep === 3) {
                        fetchSetRange()
                      }
                    }}
                    disabled={isDisabled || (currentStep === currentCountStep()) || !isSave}
                  />
                </div>


                {(currentStep === 1) && <StepItem
                  title='Шаг 1: Выбери стратегию '
                  description={
                    <>
                      Заполните все обязательные поля, которые находятся ниже и
                      нажмите на кнопку <span style={{ color: '#22C55E' }}> “Сохранить”.</span>
                      <span style={{ color: 'red' }}>
                        {' '}
                        Красными звездочками
                      </span>{' '}
                      выделены обязательные пункты для заполнения</>}
                />}

                {(currentStep === 2 && selectedStrategies?.value != 5) && (
                  <>
                    <StepItem
                      title={`Шаг 2: Установите цены`}
                    />

                    <div ref={refContainer1} className="prepared_scenarios__content">
                      <FilterContainer
                        onReset={(e) => {
                          setSelectedCategory([]);
                          setSelectedBrand([]);
                          setIsClear(!isClear);
                          resetTable();
                        }}
                      >
                        <DropDownSelector
                          options_prop={categoryData}
                          state={selectedCategory}
                          setState={setSelectedCategory}
                          placeholder="Категория"
                          total={totalCategory}
                          multi={true}
                          fetchCallback={setCategoryPage}
                          setInputChange={setCategoryQuery}
                          defaultValue={[{ label: 'Все', value: 'all' }]}
                          onBlur={() => {
                            const abortController = new AbortController();
                            brandFilter()
                            resetTable();
                            setIsTableRequest(!isTableRequest)
                          }}
                        />

                        <DropDownSelector
                          options_prop={brandData}
                          state={selectedBrand}
                          setState={setSelectedBrand}
                          placeholder="Бренд"
                          total={totalBrand}
                          multi={true}
                          fetchCallback={setBrandPage}
                          setInputChange={setBrandQuery}
                          defaultValue={[{ label: 'Все', value: 'all' }]}
                          onBlur={() => {
                            const abortController = new AbortController();
                            resetTable();
                            setIsTableRequest(!isTableRequest)
                          }}
                        />

                        <SearchComponent
                          searchValue={searchValue}
                          errSearch={false}
                          placeholder="Искать по артикулу или названию"
                          errText="Неверный артикул или название"
                          setSearchValue={setSearchValue}
                          fetchData={(e) => setIsTableRequest(!isTableRequest)}
                          fetchCallback={handleSearch}
                          data={searchData}
                          onClearDependence={[isClear]}
                        />

                      </FilterContainer>

                      {/* Только для ПОДДЕРЖАНИЕ МАРЖИНАЛЬНОСТИ */}

                      {selectedStrategies?.value === 4 &&
                        <Checkbox
                          value={isCheckAllProduct}
                          onChange={(e) => {
                            setIsCheckAllProduct(!isCheckAllProduct)
                            fetchSelectedAllCWithCost(currentСampaign?.id, !isCheckAllProduct)
                          }}
                        >
                          Выбрать все товары с себестоимостью
                        </Checkbox>}

                      {(isCheckAllProduct && selectedStrategies?.value == 4) ? null : <Tabs
                        tabs={btn_tab}
                        pageValue={pageContent}
                        setPageValue={setPageContent}
                      />}

                      {(isCheckAllProduct && selectedStrategies?.value == 4) ? null :
                        <div className='modal-create-campaign-from-rules-v2__table-group'>
                          <TableBox
                            ref={paginatorRef}
                            refContainer={refContainer1}
                            paginator={true}
                            {...tableProps}
                            fetchCallback={fetchTableDataPrice}
                            contextMenuArr={contextMenuArr}
                            onCheck={e => handleCheck(e)}
                            onUncheckAllDependence={[currentTab]}
                            onInputAction={handleSaveOnePrice}
                            onToggle={handleToggle}
                            child={<>
                              <ButtonBasic
                                blue
                                text='Шаблон загрузки Excel'
                                size='32px'
                                onClick={fetchGetTemplate}
                              />


                              <div className='prepared_scenarios__btn-upload'>
                                <ButtonBasic
                                  green
                                  text='Загрузить'
                                  size='32px'
                                />

                                <input
                                  type="file"
                                  id="fileInput"
                                  onChange={handleFileChange}
                                // style={{ display: 'none' }}
                                />
                              </div>

                              <CheckboxToggle
                                text={!isAllCheck ? 'Все включить' : 'Все выключить'}
                                value={isAllCheck}
                                onChange={(e) => {
                                  setIsAllCheck(e)
                                  fetchChangeStatusTaskAll(!isAllCheck)
                                }}
                              ></CheckboxToggle>
                            </>}
                          />
                        </div>}
                    </div>
                  </>
                )}

                {/* Изменение цены, стратегия 5 */}
                {(currentStep === 2 && selectedStrategies?.value == 5) && (
                  <>
                    <StepItem
                      title={`Шаг 2: Установите цены`}
                    />

                    <div className="prepared_scenarios__content" ref={refContainer2}>
                      <FilterContainer
                        onReset={(e) => {
                          setSelectedCategory([]);
                          setSelectedBrand([]);
                          setIsClear(!isClear);
                          resetTable();
                        }}
                      >
                        <DropDownSelector
                          options_prop={categoryData}
                          state={selectedCategory}
                          setState={setSelectedCategory}
                          placeholder="Категория"
                          total={totalCategory}
                          multi={true}
                          fetchCallback={setCategoryPage}
                          setInputChange={setCategoryQuery}
                          defaultValue={[{ label: 'Все', value: 'all' }]}
                          onBlur={() => {
                            const abortController = new AbortController();
                            brandFilter()
                            resetTable();
                            setIsTableRequestTime(!isTableRequestTime)
                          }}
                        />

                        <DropDownSelector
                          options_prop={brandData}
                          state={selectedBrand}
                          setState={setSelectedBrand}
                          placeholder="Бренд"
                          total={totalBrand}
                          multi={true}
                          fetchCallback={setBrandPage}
                          setInputChange={setBrandQuery}
                          defaultValue={[{ label: 'Все', value: 'all' }]}
                          onBlur={() => {
                            const abortController = new AbortController();
                            resetTable();
                            setIsTableRequestTime(!isTableRequestTime)
                          }}
                        />

                        <SearchComponent
                          searchValue={searchValue}
                          errSearch={false}
                          placeholder="Искать по артикулу или названию"
                          errText="Неверный артикул или название"
                          setSearchValue={setSearchValue}
                          fetchData={() => {
                            const abortController = new AbortController();
                            setIsTableRequestTime(!isTableRequestTime)
                          }}
                          fetchCallback={handleSearch}
                          data={searchData}
                          onClearDependence={[isClear]}
                        />

                      </FilterContainer>

                      <Tabs
                        tabs={btn_tab}
                        pageValue={pageContent}
                        setPageValue={setPageContent}
                      />

                      <div className='modal-create-campaign-from-rules-v2__table-group'>
                        <TableBox
                          refContainer={refContainer2}
                          ref={paginatorRef}
                          paginator={true}
                          {...tableProps}
                          fetchCallback={fetchTableDataPriceTime}
                          contextMenuArr={contextMenuArr3}
                          onCheck={handleCheck}
                          onUncheckAllDependence={[currentTab]}
                          onInputAction={handleSaveOnePriceTime}
                          onToggle={handleToggle}
                          child={<>
                            <ButtonBasic
                              blue
                              text='Шаблон загрузки Excel'
                              size='32px'
                              onClick={() => {
                                const link = document.createElement('a');
                                if (selectedMarketplace?.value === 3) {
                                  link.href = 'https://file.ecomru.ru:4453/api/v1/file/download/1a182a4f-48e7-4556-ad3f-37c27ccfc04e';
                                } else {
                                  link.href = 'https://file.ecomru.ru:4453/api/v1/file/download/7e3bdc83-8f2b-4f97-a098-c1cb15ed86c1';
                                }
                                link.download = 'price_change_strategy.xlsx'; // Имя файла
                                link.style.display = 'none'; // Скрываем ссылку
                                document.body.appendChild(link);
                                link.click();
                              }}
                            />

                            <div className='prepared_scenarios__btn-upload'>
                              <ButtonBasic
                                green
                                text='Загрузить'
                                size='32px'
                                loading={loadingUpload}
                              />

                              <input
                                type="file"
                                id="fileInput"
                                onChange={handleFileChangeTime}
                                ref={fileInputRef}
                              // style={{ display: 'none' }}
                              />
                            </div>

                            <CheckboxToggle
                              text={!isAllCheck ? 'Все включить' : 'Все выключить'}
                              value={isAllCheck}
                              onChange={(e) => {
                                setIsAllCheck(e)
                                fetchChangeStatusTaskAll(!isAllCheck)
                              }}
                            ></CheckboxToggle>
                          </>
                          }
                        />
                      </div>
                    </div>
                  </>
                )}

                {(currentStep === 4 && selectedStrategies?.value == 5) && (
                  <div className="prepared_scenarios__content">
                    <StepItem
                      title={`Шаг 3: Заполните опции.`}
                    />

                    <div
                      onBlur={(e) => {
                        if (initLoadDate) {
                          setInitLoaderDate(false);
                        }
                      }}
                    >


                      <div className='modal-create-campaign-from-rules-v2__date-group'>
                        <Checkbox
                          value={isCheckSchedule}
                          onChange={(e) => {
                            setIsCheckSchedule(!isCheckSchedule)
                            fetchCheckSchedule(currentСampaign?.id, !isCheckSchedule)
                          }}
                        >
                          Участие в акциях
                        </Checkbox>

                        <label className='modal-create-campaign-from-rules-v2__label-date'>
                          <TextPage
                            text='Дата начала задачи'
                          />
                          <SingleDatePicker
                            date={startDate}
                            setDate={setStartDate}
                            minDate={new Date()}
                            time
                          />
                        </label>

                        <label className='modal-create-campaign-from-rules-v2__label-date'>
                          <TextPage
                            text='Дата конца задачи'
                          />

                          <SingleDatePicker
                            date={endDate}
                            setDate={setEndDate}
                            minDate={new Date()}
                            time
                          />
                        </label>

                        <ButtonBasic
                          blue
                          text='Сохранить'
                          onClick={fetchSetRangeTaskTime}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {((currentStep === 3 && selectedStrategies?.value != 5) || (currentStep === 3 && selectedStrategies?.value == 5)) &&
                  <div className="prepared_scenarios__content">
                    <StepItem
                      title={`Шаг 3: Выберите период`}
                    />

                    <TimeGridSelector
                      selectedRange={selectedRange}
                      setSelectedRange={setSelectedRange}
                      interval={60}
                    />
                  </div>
                }

                {(((currentStep === 4 && selectedStrategies?.value != 5))) &&
                  <div className="prepared_scenarios__content">
                    <StepItem
                      title={`Шаг 4: Заполните атрибуты`}
                    />

                    <TitlePage
                      medium
                      title='Атрибуты'
                    />

                    {/* Атрибуты */}

                    {productTemporary?.length > 0
                      ?
                      <DynamicFormComponent
                        productTemporary={productTemporary}
                        fetchDictValues={fetchDictValues}
                        setProductTemporary={(updatedAttrs) => {
                          setProductTemporary(updatedAttrs);
                        }}
                      />
                      :
                      <TextPage
                        text='Нет доступных атрибутов'
                      />
                    }

                    <ButtonBasic
                      blue
                      width='240px'
                      style={{
                        minHeight: '40px'
                      }}
                      text='Сохранить значения атрибутов'
                      onClick={fetchSetAttr}
                      disabled={!validateRequiredValues(productTemporary)}
                    />

                    {/* Шаг 5 */}
                    {/* Для маржинальности */}
                    {
                      selectedStrategies?.value == 4 &&
                      <TableBox
                        ref={paginatorRef}
                        paginator={true}
                        {...tableProps}
                        fetchCallback={fetchTableDataCommission}
                        onToggle={handleToggleCommision}
                      />
                    }
                  </div>}

                {(selectedStrategies?.value === 4 && currentStep == 5) &&
                  <div className="prepared_scenarios__content">
                    <StepItem
                      title={`Шаг 5`}
                    />

                    <ButtonBasic
                      blue
                      width='270px'
                      text='Сделать предварительный расчет цен'
                      onClick={() => fetchPreliminaryPriceCalculation(currentСampaign?.id)}
                    />

                    <ButtonBasic
                      onClick={(e) => fetchStart(currentСampaign?.id)}
                      green
                      width='270px'
                      text='Запустить сейчас'
                      disabled={isStart}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        }
      />
    </>
  );
};

export { ModalCreateCampaignFromRules };
